import { Type } from '@uswitch/spark.type';
import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import { usePaginationContext } from './context';
import { PaginationLink } from './link';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'pagination',
  element: 'linkText'
});
export var PaginationNumber = function PaginationNumber(_ref) {
  var children = _ref.children;

  var _usePaginationContext = usePaginationContext(),
      currentPage = _usePaginationContext.currentPage,
      createPageUrl = _usePaginationContext.createPageUrl;

  var targetPageNumber = children;
  var redirectUrl = targetPageNumber !== '...' && createPageUrl(targetPageNumber);
  var isCurrent = currentPage === children;
  return _jsx(PaginationLink, {
    current: isCurrent,
    to: redirectUrl,
    children: _jsx(Type.Body2, {
      sx: {
        variant: isCurrent && variantPath('current')
      },
      children: children
    })
  });
};
PaginationNumber.propTypes = {
  children: PropTypes.number
};
PaginationNumber.displayName = 'PaginationNumber';